export default {
    getWorkTimeDates: { method: 'get', url: 'work-times/dates' },
    postWorkTimeDates: { method: 'post', url: 'work-times/dates' },
    updateWorkTimeDates: { method: 'put', url: 'work-times/dates/{id}' },
    deleteWorkTimeDates: { method: 'delete', url: 'work-times/dates/{id}' },
}
